export const LOAD_DAYS = 'LOAD_DAYS'